import { render, staticRenderFns } from "./Subscribe.vue?vue&type=template&id=5f8bc71a&"
import script from "./Subscribe.vue?vue&type=script&lang=js&"
export * from "./Subscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports